import React from 'react'
import { Components } from 'react-markdown'

/**
 * Extract text content from React children recursively
 */
const getTextContent = (children: any): string => {
    if (typeof children === 'string') {
        return children
    }
    if (Array.isArray(children)) {
        return children
            .map((child) =>
                typeof child === 'string' ? child : getTextContent(child)
            )
            .join('')
    }
    if (children?.props?.children) {
        return getTextContent(children.props.children)
    }
    return String(children || '')
}

/**
 * Custom h3 component that adds id="cookies" to the Cookies & Tracking heading
 */
export const createCookiesH3Component = (): Components['h3'] => {
    return ({ node, children, ...props }) => {
        const textContent = getTextContent(children).trim()
        // Check if this is the Cookies & Tracking heading (handles "5. Cookies & Tracking" or just "Cookies & Tracking")
        if (
            textContent.includes('Cookies & Tracking') ||
            textContent.includes('Cookies &amp; Tracking')
        ) {
            return (
                <h3 id="cookies" {...props}>
                    {children}
                </h3>
            )
        }
        return <h3 {...props}>{children}</h3>
    }
}
